<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Products</span>
        <h1>Manage product catalog.</h1>
        <p>Create, update, upload product images and hide products from the public catalog.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div class="contact-grid">

            <main class="quote-panel">
                <h2 style="font-size:32px;margin-top:0">
                    {{ model.id === 0 ? 'New Product' : 'Edit Product' }}
                </h2>

                <div class="form-grid">

                    <div class="field">
                        <label>Product Name</label>
                        <input [(ngModel)]="model.name" name="name" placeholder="Industrial Safety Helmet">
                    </div>

                    <div class="field">
                        <label>Category</label>
                        <input [(ngModel)]="model.category" name="category" placeholder="PPE">
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="model.sort" name="sort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="model.status" name="status">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full">
                        <label>Description</label>
                        <textarea [(ngModel)]="model.description" name="description" placeholder="Product description"></textarea>
                    </div>

                    <div class="field full">
                        <label>Product Image</label>
                        <input type="file" accept=".png,.jpg,.jpeg,.webp" (change)="onFileChange($event)">
                    </div>

                    <div class="field full" *ngIf="successMessage">
                        <div class="alert success">{{ successMessage }}</div>
                    </div>

                    <div class="field full" *ngIf="errorMessage">
                        <div class="alert error">{{ errorMessage }}</div>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveProduct()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Product' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newProduct()">
                            Clear
                        </button>
                    </div>

                </div>
            </main>

            <aside>
                <span class="section-kicker">Products</span>
                <h2 style="font-size:34px">Catalog list.</h2>

                <div *ngIf="loading">Loading products...</div>

                <div class="office-card premium-office" *ngFor="let p of products">
                    <div style="display:flex;gap:14px;align-items:center">
                        <img [src]="adminApi.getFileUrl(p.image)"
                             [alt]="p.name"
                             (error)="onImageError($event)"
                             style="width:72px;height:72px;object-fit:contain;border-radius:16px;background:#f4fbff;padding:8px">

                        <div style="flex:1">
                            <h3 style="margin:0 0 4px">{{ p.name }}</h3>
                            <p style="margin:0">{{ p.category }}</p>
                            <span>{{ p.status ? 'Active' : 'Hidden' }}</span>
                        </div>
                    </div>

                    <div style="display:flex;gap:8px;margin-top:14px">
                        <button class="btn btn-ghost" type="button" (click)="editProduct(p)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteProduct(p.id)">
                            Delete
                        </button>
                    </div>
                </div>
            </aside>

        </div>

    </div>
</section>